import { useMemo } from 'react'
import { IntlShape } from 'react-intl'

import { ProgramCoverageBreakdown } from '../../../models/user/User'
import { programSupportForAttribute } from '../utils'

export const useGetHighRiskSessionCount = (
  intl: IntlShape,
  clientDetails?: { employer?: string; speciality_care_session_count?: number } | null,
  selectedEpisode?: { program_name?: string },
  programCoverageBreakdown?: ProgramCoverageBreakdown,
) => {
  return useMemo(() => {
    const isCurrentProgramCoveredBySpecialtyBHB = programSupportForAttribute(
      'specialtyBhbSupported',
      selectedEpisode,
      programCoverageBreakdown,
    )

    if (isCurrentProgramCoveredBySpecialtyBHB) {
      return {
        label: intl.formatMessage({
          defaultMessage: 'High-risk sessions used',
          description: 'Number of high risk sessions used',
        }),
        value: clientDetails?.speciality_care_session_count?.toString() ?? '0',
      }
    }

    return null
  }, [programCoverageBreakdown, clientDetails?.speciality_care_session_count, intl, selectedEpisode])
}
